import {
  ThemePerformanceParams,
  ThemePerformanceResponse,
  themeOverview,
} from '@api/api/theme-overview';
import { useInfiniteQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const QUERY_KEY_GET_V5_THEME_PERFORMANCE = 'QUERY_KEY_GET_V5_THEME_PERFORMANCE';

const DEFAULT_PAGE_SIZE = 10;

/**
 * @deprecated
 */
export const useGetV5ThemePerformance = (
  params?: ThemePerformanceParams,
  enabled = true
) =>
  useInfiniteQuery({
    queryKey: [QUERY_KEY_GET_V5_THEME_PERFORMANCE, params],
    queryFn: async ({ signal, pageParam }) => {
      return await wretchRequest<ThemePerformanceResponse>(
        themeOverview.getV5ThemePerformance.path({
          ...params,
          page: pageParam,
        }),
        {
          schema: themeOverview.getV5ThemePerformance.schema,
          signal,
        }
      );
    },
    enabled,
    initialPageParam: 1,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const pageSize = params?.page_size ?? DEFAULT_PAGE_SIZE;
      return lastPage.themes.length === pageSize
        ? lastPageParam + 1
        : undefined;
    },
  });
